var render = function render(){var _vm=this,_c=_vm._self._c;return (this.docPath)?_c('span',{staticClass:"pull-right mr-2"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.click}},[_c('i',{staticClass:"text-primary far fa-user question d-none"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }